import { render, staticRenderFns } from "./MapPolicies.vue?vue&type=template&id=d464f666"
import script from "./MapPolicies.vue?vue&type=script&lang=js"
export * from "./MapPolicies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports